import { PLATFORM } from 'aurelia-pal';
import SimpleStorage from 'wootils/esm/browser/simpleStorage';

class AppRequestsStorage extends SimpleStorage {
  constructor(appConfiguration, appLogger) {
    'inject';

    super({
      window: PLATFORM.global,
      storage: {
        name: 'appRequestsStorage',
        key: appConfiguration.get('storageKeys.requests'),
      },
      entries: {
        enabled: true,
      },
      logger: appLogger,
    });
  }
  save(name, reqFn) {
    let result;
    const cached = this._getEntryValue(name);
    if (cached) {
      result = Promise.resolve(cached);
    } else {
      result = this._addEntry(name, reqFn());
    }

    return result;
  }
}

export { AppRequestsStorage };
